// ── QK Academy Offline Database (Dexie / IndexedDB) ─────────────
// Persists across page refreshes, tab closes, and browser restarts.
// Data is cleared only if the user manually wipes browser site data.
import Dexie from 'dexie';
export const db = new Dexie('QKAcademyOffline');
db.version(1).stores({
  // Each table: primary key + indexed columns
  // synced: 0 = pending upload, 1 = uploaded to Supabase
  students:      '++_lid, id, synced',       // _lid = local auto-id
  attendance:    '++_lid, date, student_id, synced',
  fee_payments:  '++_lid, student_id, month, synced',
  scholarships:  '++_lid, student_name, synced',
  exams:         '++_lid, id, synced',
  results:       '++_lid, student_id, exam_id, synced',
  staff:         '++_lid, id, synced',
  salary_payments: '++_lid, staff_id, synced',
  timetable:     '++_lid, id, synced',
  sync_log:      '++id, table_name, action, ts',  // audit trail
});
db.version(2).stores({
  attendance: '++_lid, date, student_id, synced, [date+student_id]',
});
/** How many records are waiting to sync */
export async function getPendingCount() {
  const tables = [
    db.students, db.attendance, db.fee_payments,
    db.scholarships, db.exams, db.results,
    db.staff, db.salary_payments, db.timetable,
  ];
  let total = 0;
  for (const t of tables) {
    total += await t.where('synced').equals(0).count();
  }
  return total;
}
/** Mark a local record as synced */
export async function markSynced(tableName, lid) {
  await db[tableName].update(lid, { synced: 1 });
}
/** Log a sync event */
export async function logSync(tableName, action, status, message) {
  await db.sync_log.add({ table_name: tableName, action, status, message: message || null, ts: Date.now() });
}
